export default __webpack_public_path__ + "static/media/logo_julian_notes_dark.6e8dbd89.svg";